

export function HomePage() {
    return(
        <div style={{ textAlign: 'center', padding: '40px 20px', maxWidth: '600px', margin: '0 auto' }}>
            <h2>Our homepage, your home</h2>
            
             Welcome to Mountain Bike Costa Rica. We are a website dedicated to providing information and resources for mountain biking in Costa Rica. 
             Whether you are a local resident or a tourist looking to explore the beautiful trails of Costa Rica, we have something for everyone. 
             Our website features a variety of content, including trail guides, bike rental information, and tips for riding in Costa Rica. 
             We also have a community forum where you can connect with other mountain biking enthusiasts and share your experiences. 
             Thank you for visiting our website, and we hope you find it helpful and informative! 
        </div>
    );
}


